{
  "v8c.webhooks.actif": "Active",
  "v8c.webhooks.activation.active": "Webhook enabled: subscribed events are delivered to it.",
  "v8c.webhooks.activation.activer": "Enable the webhook",
  "v8c.webhooks.activation.confirmation_activer": "Enable this webhook? Subscribed events will be delivered to it.",
  "v8c.webhooks.activation.confirmation_desactiver": "Disable this webhook? No event will be delivered to it any more.",
  "v8c.webhooks.activation.desactive": "Webhook disabled: no event is delivered to it any more.",
  "v8c.webhooks.activation.desactiver": "Disable the webhook",
  "v8c.webhooks.activation.echec": "The state could not be changed.",
  "v8c.webhooks.annuler": "Cancel",
  "v8c.webhooks.catalogue.libelle": "Event catalogue",
  "v8c.webhooks.catalogue.vide": "No event can be subscribed to.",
  "v8c.webhooks.categorie.derogations": "Waivers",
  "v8c.webhooks.categorie.membres": "Members",
  "v8c.webhooks.categorie.projets": "Projects",
  "v8c.webhooks.categorie.sprints": "Sprints",
  "v8c.webhooks.categorie.versions": "Releases",
  "v8c.webhooks.champ.adresse": "Destination address",
  "v8c.webhooks.champ.adresse_aide": "https address; the host is checked by the platform (allowed destinations, no internal network).",
  "v8c.webhooks.champ.evenements": "Subscribed events",
  "v8c.webhooks.champ.nom": "Name",
  "v8c.webhooks.cible.android": "Android",
  "v8c.webhooks.cible.compte_app_store": "App Store account",
  "v8c.webhooks.cible.compte_google_play": "Google Play account",
  "v8c.webhooks.cible.compte_microsoft_store": "Microsoft Store account",
  "v8c.webhooks.cible.ios": "iOS",
  "v8c.webhooks.cible.macos": "macOS",
  "v8c.webhooks.cible.windows": "Windows",
  "v8c.webhooks.code.CONFLIT_CONCURRENT": "Changed in the meantime: reload before saving.",
  "v8c.webhooks.code.CONTEXTE_INCOMPLET": "Incomplete context: reopen the organisation.",
  "v8c.webhooks.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v8c.webhooks.code.EGRESS_HOST_NOT_ALLOWED": "Host not in the list of allowed destinations.",
  "v8c.webhooks.code.EGRESS_METADATA_BLOCKED": "Address refused: metadata or link-local address.",
  "v8c.webhooks.code.GARDE_DROIT_ABSENTE": "Action not guarded by a right: refused.",
  "v8c.webhooks.code.RESOURCE_UNAVAILABLE": "Object not found or from another organisation.",
  "v8c.webhooks.code.SANS_SESSION": "Session expired: sign in again.",
  "v8c.webhooks.code.SIGNATURE_CIBLE_DIFFERENTE": "The new key must target the same platform as the old one.",
  "v8c.webhooks.code.SIGNATURE_EXPIRATION_ANTERIEURE": "The expiry must be later than the old key’s.",
  "v8c.webhooks.code.SIGNATURE_EXPIRATION_PASSEE": "The expiry date is in the past.",
  "v8c.webhooks.code.SIGNATURE_FORMAT_REFUSE": "File or credentials unreadable for this target.",
  "v8c.webhooks.code.VALIDATION_ERROR": "Invalid input: check the fields.",
  "v8c.webhooks.code.WEBHOOK_ADRESSE_INTERNE": "Address refused: it leads to an internal network.",
  "v8c.webhooks.code.WEBHOOK_DESACTIVE": "Webhook disabled: enable it to send a test.",
  "v8c.webhooks.code.WEBHOOK_HTTPS_EXIGE": "The address must start with https://.",
  "v8c.webhooks.code.WEBHOOK_NOM_DEJA_PRIS": "A webhook with this name already exists in the organisation.",
  "v8c.webhooks.col.actions": "Actions",
  "v8c.webhooks.col.derniere_livraison": "Last delivery",
  "v8c.webhooks.col.etat": "State",
  "v8c.webhooks.col.evenements": "Events",
  "v8c.webhooks.col.nom": "Name",
  "v8c.webhooks.confirmer": "Confirm",
  "v8c.webhooks.creer.bouton": "Create the webhook",
  "v8c.webhooks.creer.bouton_ouvrir": "Create a webhook",
  "v8c.webhooks.creer.echec": "The webhook could not be created.",
  "v8c.webhooks.creer.titre": "Create an organisation webhook",
  "v8c.webhooks.desactive": "Disabled",
  "v8c.webhooks.essai.bouton": "Send a test event",
  "v8c.webhooks.essai.desactive": "Webhook disabled: enable it to send a test.",
  "v8c.webhooks.essai.echec": "The test could not be sent.",
  "v8c.webhooks.essai.reponse": "Response received: {{resultat}}",
  "v8c.webhooks.etat.chargement": "Loading: {{quoi}}…",
  "v8c.webhooks.etat.en_cours": "In progress…",
  "v8c.webhooks.etat.erreur": "Could not read: {{quoi}}.",
  "v8c.webhooks.etat.introuvable": "{{quoi}} not found.",
  "v8c.webhooks.etat.reessayer": "Retry",
  "v8c.webhooks.etat.refus": "Access denied: {{quoi}}.",
  "v8c.webhooks.evenement.derogation.accordee": "Waiver granted",
  "v8c.webhooks.evenement.derogation.refusee": "Waiver refused",
  "v8c.webhooks.evenement.invitation.acceptee": "Invitation accepted",
  "v8c.webhooks.evenement.membre.ajoute_au_projet": "Member added to a project",
  "v8c.webhooks.evenement.membre.desactive": "Member deactivated",
  "v8c.webhooks.evenement.membre.retire_du_projet": "Member removed from a project",
  "v8c.webhooks.evenement.projet.archive": "Project archived",
  "v8c.webhooks.evenement.projet.cree": "Project created",
  "v8c.webhooks.evenement.projet.desarchive": "Project unarchived",
  "v8c.webhooks.evenement.projet.renomme": "Project renamed",
  "v8c.webhooks.evenement.projet.suppression_demandee": "Project deletion requested",
  "v8c.webhooks.evenement.sprint.clos": "Sprint closed",
  "v8c.webhooks.evenement.version.deploiement_planifie": "Deployment planned",
  "v8c.webhooks.evenement.version.gel_declare": "Release freeze declared",
  "v8c.webhooks.evenement.webhook.essai": "Test event",
  "v8c.webhooks.fiche.cree": "Created",
  "v8c.webhooks.fiche.libelle": "Webhook",
  "v8c.webhooks.fiche.modifie": "Modified",
  "v8c.webhooks.fiche.par_le": "{{qui}}, {{date}}",
  "v8c.webhooks.fiche.titre": "Organisation webhook",
  "v8c.webhooks.liste.aucune_livraison": "No delivery",
  "v8c.webhooks.liste.intro": "Organisation webhooks send its events, signed, to your tools.",
  "v8c.webhooks.liste.libelle": "Webhooks",
  "v8c.webhooks.liste.titre": "Organisation webhooks",
  "v8c.webhooks.liste.vide": "No webhook in the organisation.",
  "v8c.webhooks.livraison.statut.en_attente": "Pending",
  "v8c.webhooks.livraison.statut.en_echec": "Failed",
  "v8c.webhooks.livraison.statut.reussie": "Succeeded",
  "v8c.webhooks.livraisons.essai": "test",
  "v8c.webhooks.livraisons.libelle": "Recent deliveries",
  "v8c.webhooks.livraisons.nouvelle_tentative": "Next attempt planned on {{date}}",
  "v8c.webhooks.livraisons.titre": "Recent deliveries",
  "v8c.webhooks.livraisons.vide": "No recent delivery.",
  "v8c.webhooks.modifier.bouton": "Save the change",
  "v8c.webhooks.modifier.bouton_ouvrir": "Edit the webhook",
  "v8c.webhooks.modifier.conflit": "This webhook was changed in the meantime: reload it before saving.",
  "v8c.webhooks.modifier.echec": "The change could not be saved.",
  "v8c.webhooks.modifier.effets": "Effects of the change",
  "v8c.webhooks.modifier.livraisons_en_attente": "Pending deliveries go to the new address.",
  "v8c.webhooks.modifier.nouvelle_verification": "The new destination will be checked again by the platform.",
  "v8c.webhooks.modifier.relire": "Reload",
  "v8c.webhooks.modifier.rien": "Nothing to save: no change.",
  "v8c.webhooks.modifier.secret_inchange": "The signing secret stays unchanged.",
  "v8c.webhooks.modifier.titre": "Edit an organisation webhook",
  "v8c.webhooks.modifier.vise": "Webhook “{{nom}}”, version {{version}}.",
  "v8c.webhooks.onglet.apercu": "Overview",
  "v8c.webhooks.onglet.webhooks": "Webhooks",
  "v8c.webhooks.onglets": "Organisation sections",
  "v8c.webhooks.projets.actif_un": "{{n}} enabled",
  "v8c.webhooks.projets.actifs": "{{n}} enabled",
  "v8c.webhooks.projets.desactive_un": "{{n}} disabled",
  "v8c.webhooks.projets.desactives": "{{n}} disabled",
  "v8c.webhooks.projets.explication": "Each project manages its own webhooks; they are counted here for information.",
  "v8c.webhooks.projets.libelle": "Project webhooks",
  "v8c.webhooks.projets.ligne": "{{nom}}: {{actifs}}, {{desactives}}",
  "v8c.webhooks.projets.titre": "Project webhooks",
  "v8c.webhooks.projets.vide": "No project has a webhook.",
  "v8c.webhooks.renouveler.bouton": "Renew the secret",
  "v8c.webhooks.renouveler.confirmation": "The old secret will stop working at once: your tools must use the new one. Renew?",
  "v8c.webhooks.renouveler.confirmer": "Renew now",
  "v8c.webhooks.renouveler.echec": "Renewal failed: the old secret stays valid.",
  "v8c.webhooks.renouveler.fait": "Secret renewed: the old one no longer works.",
  "v8c.webhooks.secret.copie": "Secret copied.",
  "v8c.webhooks.secret.copie_refusee": "The browser refused to copy: select the secret and copy it.",
  "v8c.webhooks.secret.copier": "Copy the secret",
  "v8c.webhooks.secret.doublon": "This creation was already recorded: the secret was shown on the first submission.",
  "v8c.webhooks.secret.jamais_reaffiche": "The signing secret is never shown again; renew it if you lost it.",
  "v8c.webhooks.secret.titre": "Signing secret",
  "v8c.webhooks.secret.une_fois": "This secret is shown only once: copy it into your tool now.",
  "v8c.webhooks.secret.valeur": "Secret",
  "v8c.webhooks.signature.hmac": "Each delivery is signed (HMAC-SHA256 of the body, X-DoIt-Signature header) with the webhook secret.",
  "v8c.webhooks.signature.titre": "Delivery signature",
  "v8c.webhooks.signature.une_fois": "The signing secret is shown only once, after creation.",
  "v8c.webhooks.signature_app.aide_identifiants.compte_app_store": "Expected fields: issuer_id, key_id, private_key (PEM).",
  "v8c.webhooks.signature_app.aide_identifiants.compte_google_play": "Google service account: type, client_email, private_key (PEM).",
  "v8c.webhooks.signature_app.aide_identifiants.compte_microsoft_store": "Expected fields: tenant_id, client_id, client_secret.",
  "v8c.webhooks.signature_app.applications": "Applications using it: {{n}}",
  "v8c.webhooks.signature_app.applications_inconnues": "Applications using it: count provided by the signed build (to come).",
  "v8c.webhooks.signature_app.champ.cible": "Target",
  "v8c.webhooks.signature_app.champ.expiration": "Expiry date",
  "v8c.webhooks.signature_app.champ.fichier": "Key file (PKCS#12, keystore or certificate)",
  "v8c.webhooks.signature_app.champ.identifiants": "Account credentials (JSON)",
  "v8c.webhooks.signature_app.champ.mot_de_passe": "File password",
  "v8c.webhooks.signature_app.champ.nouveau_fichier": "New key file (PKCS#12, keystore or certificate)",
  "v8c.webhooks.signature_app.choisie.aucune": "Select a key to see its fingerprint and expiry.",
  "v8c.webhooks.signature_app.choisie.titre": "Selected key",
  "v8c.webhooks.signature_app.choisir": "Select",
  "v8c.webhooks.signature_app.choisir_d_abord": "Select a key first.",
  "v8c.webhooks.signature_app.choisir_la_cle": "Select {{nom}}",
  "v8c.webhooks.signature_app.cle_libelle": "Signing key",
  "v8c.webhooks.signature_app.col.cible": "Target",
  "v8c.webhooks.signature_app.col.expire_le": "Expires on",
  "v8c.webhooks.signature_app.dialogue_titre": "Register a signing key or a store account",
  "v8c.webhooks.signature_app.empreinte": "Fingerprint",
  "v8c.webhooks.signature_app.enregistree": "Registered",
  "v8c.webhooks.signature_app.enregistrement_echec": "The key could not be registered.",
  "v8c.webhooks.signature_app.enregistrer": "Register a key",
  "v8c.webhooks.signature_app.enregistrer_la_cle": "Register the key",
  "v8c.webhooks.signature_app.expiration_lue": "Left empty, it is read from the certificate.",
  "v8c.webhooks.signature_app.expiration_passee": "The expiry date is in the past.",
  "v8c.webhooks.signature_app.intro": "Signing keys and store accounts of the organisation, used by signed release builds.",
  "v8c.webhooks.signature_app.jamais_reaffiche": "Key material (file, password, credentials) is never shown again.",
  "v8c.webhooks.signature_app.liste.libelle": "Signing keys",
  "v8c.webhooks.signature_app.liste.vide": "No signing key or store account.",
  "v8c.webhooks.signature_app.onglet.catalogue_technologique": "Technology catalogue",
  "v8c.webhooks.signature_app.onglet.charte": "Charter",
  "v8c.webhooks.signature_app.onglet.chemin_dore": "Golden path",
  "v8c.webhooks.signature_app.onglet.derogations": "Waivers",
  "v8c.webhooks.signature_app.onglet.exigences": "Requirements",
  "v8c.webhooks.signature_app.onglet.regles": "Three-step rules",
  "v8c.webhooks.signature_app.onglet.sante": "Compliance health",
  "v8c.webhooks.signature_app.onglets": "Governance sections",
  "v8c.webhooks.signature_app.plus_active": "Key removed or replaced: action unavailable.",
  "v8c.webhooks.signature_app.proposer_remplacement": "Expires soon: replace it before it expires.",
  "v8c.webhooks.signature_app.remplacement.ancienne_valable": "The old key stays valid until confirmation.",
  "v8c.webhooks.signature_app.remplacement.cle_remplacee": "Key being replaced",
  "v8c.webhooks.signature_app.remplacement.confirmer": "Confirm the replacement",
  "v8c.webhooks.signature_app.remplacement.echec": "Replacement failed: the old key alone stays valid.",
  "v8c.webhooks.signature_app.remplacement.echec_ancienne_seule": "If confirmation fails, the old key alone stays valid and the new one is not kept.",
  "v8c.webhooks.signature_app.remplacement.effets": "Effects of the replacement",
  "v8c.webhooks.signature_app.remplacement.retiree": "This key is no longer active (removed or replaced in the meantime): nothing to replace.",
  "v8c.webhooks.signature_app.remplacement.titre": "Replace a signing key",
  "v8c.webhooks.signature_app.remplacement.versions_suivantes": "Following releases will be signed by the new one.",
  "v8c.webhooks.signature_app.remplacer": "Replace the key",
  "v8c.webhooks.signature_app.requise_en_production": "Required in production.",
  "v8c.webhooks.signature_app.retrait.bouton": "Remove the key",
  "v8c.webhooks.signature_app.retrait.confirmation": "Remove “{{nom}}”? Following releases will no longer be signed with it.",
  "v8c.webhooks.signature_app.retrait.confirmer": "Remove permanently",
  "v8c.webhooks.signature_app.retrait.echec": "The key could not be removed.",
  "v8c.webhooks.signature_app.retrait.fait": "Key removed; the removal is written to the log.",
  "v8c.webhooks.signature_app.sous_onglet.catalogue": "Catalogue",
  "v8c.webhooks.signature_app.sous_onglet.categories": "Categories",
  "v8c.webhooks.signature_app.sous_onglet.changements": "Changes",
  "v8c.webhooks.signature_app.sous_onglet.elements_qualifies": "Qualified items",
  "v8c.webhooks.signature_app.sous_onglet.nouvelles_piles": "New stacks and suggestions",
  "v8c.webhooks.signature_app.sous_onglet.radar": "Radar",
  "v8c.webhooks.signature_app.sous_onglet.signature": "Application signing",
  "v8c.webhooks.signature_app.sous_onglets": "Technology catalogue sections",
  "v8c.webhooks.signature_app.statut.active": "Active",
  "v8c.webhooks.signature_app.statut.expire_bientot": "Expires soon",
  "v8c.webhooks.signature_app.statut.expiree": "Expired",
  "v8c.webhooks.signature_app.statut.remplacee": "Replaced",
  "v8c.webhooks.signature_app.statut.retiree": "Removed",
  "v8c.webhooks.signature_app.titre": "Application signing",
  "v8c.webhooks.suppression.bouton": "Delete the webhook",
  "v8c.webhooks.suppression.confirmation": "Permanently delete “{{nom}}” and its deliveries?",
  "v8c.webhooks.suppression.confirmer": "Delete permanently",
  "v8c.webhooks.suppression.echec": "Deletion failed: the record stays open, try again.",
  "v8c.webhooks.suppression.faite": "Webhook “{{nom}}” deleted.",
  "v8c.webhooks.tous_les_webhooks": "All webhooks",
  "v8c.webhooks.validation.aucun_evenement": "Choose at least one event.",
  "v8c.webhooks.validation.https": "The address must start with https://.",
  "v8c.webhooks.validation.nom": "Name required, 100 characters at most.",
  "v8c.webhooks.voir": "View",
  "v8c.webhooks.voir_le_webhook": "View webhook {{nom}}"
}
